import _ from 'underscore';
import { GoogleLoginRepository as GoogleLoginBaseRepository } from '@bingads-webui/google-login-repository';

const OAUTH_SCOPE = 'https://www.googleapis.com/auth/adwords https://www.googleapis.com/auth/userinfo.email';

export function getClientId(domain) {
  const bingAdsProdPattern = /ui(.beta)?(.tip)?.bingads.microsoft.com$/;
  const msadProdPattern = /ui(.beta)?(.tip)?.ads.microsoft.com$/;

  const msadProdSignupPattern = /^(beta.)?(tip.)?ads.microsoft.com$/;
  const bingAdsSignupPattern = /^(beta.)?(tip.)?bingads.microsoft.com$/;

  const sdkProdSginupPattern = /^sdk(beta|tip)?.(ads|bingads).microsoft.com$/;
  if (
    _.isNull(domain.match(bingAdsProdPattern)) &&
    _.isNull(domain.match(msadProdPattern)) &&
    _.isNull(domain.match(msadProdSignupPattern)) &&
    _.isNull(domain.match(sdkProdSginupPattern)) &&
    _.isNull(domain.match(bingAdsSignupPattern))
  ) {
    return '640802097284-nctqt4ptlhnksuj8lu24ana6iqgd05r8.apps.googleusercontent.com';
  }

  return '639188481088-c2nvr8kbh33s2v06gooask751o1hgis1.apps.googleusercontent.com';
}

export class GoogleLoginRepository extends GoogleLoginBaseRepository {
  constructor({ deps }) {
    const { google, GSILocal } = deps;
    super({
      scope: OAUTH_SCOPE,
      clientId: getClientId(document.domain),
      GSILocal,
      google,
    });
  }
}
